export const robots = [
{
	id: 1, 
	name: 'Erik Mai',
	username: 'MaiMeatStick',
	email: 'airwickmai@gmail.com'
},
{
	id: 2, 
	name: 'Cindy Phan',
	username: 'CindyAngel10',
	email: 'cindyangel@gmail.com'
},
{
	id: 3, 
	name: 'Hieu Le',
	username: 'hugheslyfe',
	email: 'hieule17@gmail.com'
},
{
	id: 4, 
	name: 'Dustin Mai',
	username: 'dusteez',
	email: 'dustinmnmn@gmail.com'
},
{
	id: 5, 
	name: 'Kevin Mai',
	username: 'crucifix',
	email: 'kmai09@gmail.com'
},
{
	id: 6, 
	name: 'Steven Bui',
	username: 'SimpleDimple',
	email: 'sbui13@gmail.com'
},
{
	id: 7, 
	name: 'Dustin Bui',
	username: 'Pepsi009',
	email: 'dbui12@gmail.com'
}
];